<template lang="pug">
  div.registry.objects
    e-toolbar(
      table-id="tkoObjects"
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getEndpointExport"
    )

    e-table(
      tableWrapperClass="table"
      :items="items"
      @editItem="editItem"
      :showDeleteButton="false"
      :showCheckbox="false"
      :showPagination="false"
      :actionColumnWidth="130"
    )
      template(slot="group" slot-scope="props")
        div(v-if="props.row.has_children")
          div(
            v-if="!isOpened(props.row)"
            :class="getItemClass(props.row)"
            @click.stop.prevent="openChild(props.row)"
          ).item.with-actions.close
            span.arrow
            span {{props.row.group}}
          div(
            v-else
            :class="getItemClass(props.row)"
            @click.stop.prevent="closeChild(props.row)"
          ).item.with-actions.open
            span.arrow
            span {{props.row.group}}
        div(
          v-else
          :class="getItemClass(props.row)"
        ).item
          span.arrow
          span {{props.row.group}}

      div(slot="actionButtons" slot-scope="props").actions
        button.row-edit(
          v-if="props.acceptEdit && !props.row.has_children"
          @click.stop.prevent="editItem(props.row)"
        )
        button.row-delete(
          v-if="props.acceptDelete  && !props.row.has_children"
          @click.stop.prevent="deleteItem(props.row)"
        )

    router-view
</template>

<script>
import {tko, export_document} from '../../../api/api-endpoints.js'
import tableMixin from '../../../components/table/table-mixin.js'
import url from '../../../utils/url.js'
import {LEVEL_CSS_CLASS_MAP} from "../../../config/config";

export default {
  mixins: [tableMixin],
  computed: {
    meta() {
      return this.items?._meta || {fields: {}}
    }
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler() {
        this.updateTableState()
      }
    }
  },
  methods: {
    updateTableState () {
      if (Object.keys(this.meta).length > 0) {
        this.$sharedServices.store.commit('tableState', {
          id: 'tkoObjects',
          param: 'meta',
          data: this.meta
        })
      }
    },
    createItem (item) {
      let query = {
        prevRoute: url.getRoute(this.$route, true),
        setFields: JSON.stringify({
          parent_id: item.id
        })
      }
      this.$router.push({
        name: this.$route.name + '.create',
        query
      })
    },
    getEndpointExport(){
      return export_document.tkoObject(this.$route)
    },
    getDeleteUrl (id) {
      return tko.objectDelete(id)
    },
    getEndpoint (route, fromRoute) {
      return tko.objects(route)
    },
    editItem({id}) {
      this.$router.push({
        name:   'registry.objects.update',
        params: {id: id}
      })
    },
    deleteItem({ id }) {
      const url = tko.objectDelete(id)
      this.$e.confirmBox().then(() => {
        this.$store.dispatch('deleteModel', { url })
          .then(() => this.$e.successBox('Запись успешно удалена')
          ).catch(erResponse => this.$e.errorBox(erResponse))
      })
    },
    getItemClass (item) {
      let lvl = +(item.lvl || 1)
      if (LEVEL_CSS_CLASS_MAP[lvl]) {
        return LEVEL_CSS_CLASS_MAP[lvl]
      }
      return ''
    },
    isOpened (item) {
      return this.items.data.findIndex(v => v.parent_id === item.id) > -1
    },
    closeChild (row) {
      let ids = []
      this.items.data.forEach(v => {
        if (v.parent_id === row.id) {
          ids.push(v.id)
          this.closeChild(v)
        }
      })

      this.$store.dispatch('deleteModels', {
        endpoint: this.getEndpoint(this.$route),
        ids: ids,
        offline: true
      })
    },
    openChild (row) {
      if (this.isOpened(row)) {
        return false
      }

      let query = Object.assign({}, this.$route.query, {
        parent_id: row.id,
        'per-page': -1
      });

      this.$bar.start()
      this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getEndpoint({
          query: query
        }),
        useCache: true,
        params: {
          disableGlobalError: true
        }
      }).then(response => {
        let parentLvl = row.lvl || 1
        response.data.data.forEach((v, i) => {
          response.data.data[i].lvl = parentLvl + 1
        })
        this.$store.commit('mutateEndpoint', {
          endpoint: this.getEndpoint(this.$route),
          action: 'insertAfter',
          id: row.id,
          response
        })
        this.$bar.finish()
      }).catch(e => {
        this.showOnError(e)
        this.$bar.finish()
      })
    }
  }
}
</script>

